/* ===================================================================
   VEDARA theme interactions — vanilla, accessible, dependency-free
   =================================================================== */
(function(){
  'use strict';
  var reduce = matchMedia('(prefers-reduced-motion:reduce)').matches;

  /* ---------- header: scrolled state + hide-on-down / reveal-on-up ---------- */
  var hdr = document.getElementById('site-header');
  if(hdr){
    var lastY = window.scrollY;
    var ticking = false;
    var REVEAL_AT = 8;        // px past which the "floating" treatment kicks in
    var HIDE_AFTER = 140;     // don't hide until the user is genuinely down the page
    var DELTA = 6;            // ignore sub-pixel jitter
    var evalHeader = function(){
      ticking = false;
      var y = window.scrollY;
      hdr.classList.toggle('is-scrolled', y > REVEAL_AT);
      // never hide when reduced-motion, near the top, when an overlay is open,
      // or when focus is inside the header (keyboard users)
      var overlayOpen = document.body.style.overflow === 'hidden';
      var focusInHdr = hdr.contains(document.activeElement);
      if(reduce || y < HIDE_AFTER || overlayOpen || focusInHdr){
        hdr.classList.remove('is-hidden');
      } else if(Math.abs(y - lastY) > DELTA){
        hdr.classList.toggle('is-hidden', y > lastY); // scrolling down hides, up reveals
      }
      lastY = y;
    };
    addEventListener('scroll', function(){
      if(!ticking){ requestAnimationFrame(evalHeader); ticking = true; }
    }, {passive:true});
    evalHeader();
  }

  /* ---------- focus trap helper ---------- */
  function trap(container){
    var sel = 'a[href],button:not([disabled]),input,textarea,select,[tabindex]:not([tabindex="-1"])';
    var f = container.querySelectorAll(sel);
    if(!f.length) return function(){};
    var first=f[0], last=f[f.length-1];
    function handler(e){
      if(e.key!=='Tab') return;
      if(e.shiftKey && document.activeElement===first){ e.preventDefault(); last.focus(); }
      else if(!e.shiftKey && document.activeElement===last){ e.preventDefault(); first.focus(); }
    }
    container.addEventListener('keydown', handler);
    return function(){ container.removeEventListener('keydown', handler); };
  }

  /* ---------- generic overlay controller ---------- */
  function overlay(el, opener){
    if(!el) return null;
    var untrap=null, lastFocus=null;
    var api={
      open:function(){
        lastFocus=document.activeElement;
        el.setAttribute('aria-hidden','false');
        document.body.style.overflow='hidden';
        untrap=trap(el);
        var f=el.querySelector('input,button,a[href]'); if(f) setTimeout(function(){f.focus();},60);
      },
      close:function(){
        el.setAttribute('aria-hidden','true');
        document.body.style.overflow='';
        if(untrap) untrap();
        if(lastFocus) lastFocus.focus();
      },
      toggle:function(){ el.getAttribute('aria-hidden')==='false'?api.close():api.open(); }
    };
    el.addEventListener('click', function(e){
      if(e.target.closest('[data-overlay-close],.drawer__scrim,.search-modal__scrim,.mobile-nav__scrim')) api.close();
    });
    addEventListener('keydown', function(e){ if(e.key==='Escape' && el.getAttribute('aria-hidden')==='false') api.close(); });
    return api;
  }

  /* ---------- cart drawer ---------- */
  var cartDrawer = overlay(document.getElementById('cart-drawer'));
  if(cartDrawer){
    document.querySelectorAll('[data-cart-open]').forEach(function(b){
      b.addEventListener('click', function(e){ e.preventDefault(); cartDrawer.open(); });
    });
    window.__openCart = cartDrawer.open;
    window.__refreshCart = refreshCart;
  }

  /* ---------- mobile nav ---------- */
  var mnav = overlay(document.getElementById('mobile-nav'));
  if(mnav){
    document.querySelectorAll('[data-menu-open]').forEach(function(b){
      b.addEventListener('click', function(e){ e.preventDefault(); mnav.open(); });
    });
  }

  /* ---------- search modal + predictive ---------- */
  var searchModal = overlay(document.getElementById('search-modal'));
  if(searchModal){
    document.querySelectorAll('[data-search-open]').forEach(function(b){
      b.addEventListener('click', function(e){ e.preventDefault(); searchModal.open(); });
    });
    var input = document.getElementById('predict-input');
    var results = document.getElementById('predict-results');
    var timer;
    if(input && results){
      input.addEventListener('input', function(){
        clearTimeout(timer);
        var q = input.value.trim();
        if(q.length<2){ results.innerHTML=''; return; }
        timer = setTimeout(function(){ predict(q, results); }, 200);
      });
    }
  }

  function predict(q, out){
    var url = '/search/suggest.json?q='+encodeURIComponent(q)+'&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
    fetch(url).then(function(r){return r.json();}).then(function(data){
      var items = (data.resources && data.resources.results && data.resources.results.products) || [];
      if(!items.length){ out.innerHTML='<p class="muted" style="padding:1em">No products found for "'+escapeHtml(q)+'".</p>'; return; }
      out.innerHTML = items.map(function(p){
        var img = p.featured_image && p.featured_image.url ? '<img src="'+p.featured_image.url+'&width=96" alt="" loading="lazy">' : '';
        return '<a class="predict-item" href="'+p.url+'"><span class="predict-item__media">'+img+'</span>'+
          '<span><span class="predict-item__title">'+escapeHtml(p.title)+'</span><br>'+
          '<span class="predict-item__price">'+(p.price?formatMoney(p.price):'')+'</span></span></a>';
      }).join('');
    }).catch(function(){ out.innerHTML='<p class="muted" style="padding:1em">Search is unavailable right now.</p>'; });
  }

  /* ---------- add to cart (AJAX) ---------- */
  document.addEventListener('submit', function(e){
    var form = e.target.closest('form[action*="/cart/add"]');
    if(!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    // update an inner label element if present so button styling survives state changes
    var labelEl = btn ? (btn.querySelector('.plate__add-label') || btn.querySelector('.card__add-label') || btn.querySelector('[data-btn-label]')) : null;
    var target = labelEl || btn;
    var label = target ? target.textContent : '';
    if(btn){ btn.disabled=true; btn.setAttribute('aria-busy','true'); }
    if(target){ target.textContent='Adding\u2026'; }
    var data = new FormData(form);
    fetch('/cart/add.js', {method:'POST', body:data, headers:{'Accept':'application/json'}})
      .then(function(r){ if(!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function(){
        if(target){ target.textContent='Added \u2713'; }
        return refreshCart();
      })
      .then(function(){
        if(window.__openCart) window.__openCart();
        setTimeout(function(){ if(btn){ btn.disabled=false; btn.removeAttribute('aria-busy'); } if(target){ target.textContent=label; } }, 1200);
      })
      .catch(function(){ if(btn){ btn.disabled=false; btn.removeAttribute('aria-busy'); } if(target){ target.textContent=label; } });
  });

  /* ---------- cart quantity + remove (in drawer & page) ---------- */
  document.addEventListener('click', function(e){
    var rm = e.target.closest('[data-cart-remove]');
    if(rm){ e.preventDefault(); changeLine(rm.getAttribute('data-cart-remove'), 0); return; }
    var qb = e.target.closest('[data-qty]');
    if(qb){
      e.preventDefault();
      var wrap = qb.closest('.qty'); var inp = wrap.querySelector('input');
      var v = parseInt(inp.value,10)||1;
      v = qb.getAttribute('data-qty')==='up' ? v+1 : Math.max(1,v-1);
      inp.value=v;
      var key = qb.getAttribute('data-line');
      if(key) changeLine(key, v);
    }
  });

  function changeLine(key, qty){
    fetch('/cart/change.js', {method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({id:key, quantity:qty})})
      .then(function(r){return r.json();}).then(function(){ refreshCart(); });
  }

  function refreshCart(){
    return fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(function(cart){
      document.querySelectorAll('[data-cart-count]').forEach(function(el){
        el.textContent = cart.item_count;
        el.hidden = cart.item_count===0;
      });
      return renderDrawer(cart);
    });
  }

  function renderDrawer(cart){
    var box = document.getElementById('drawer-items');
    var sub = document.getElementById('drawer-subtotal');
    var foot = document.getElementById('drawer-foot');
    if(!box) return cart;
    if(cart.item_count===0){
      box.innerHTML = '<div class="drawer__empty"><p>Your cart is empty.</p><a class="btn btn--ghost" href="/collections/all">Explore the collection</a></div>';
      if(foot) foot.hidden = true;
      return cart;
    }
    if(foot) foot.hidden = false;
    box.innerHTML = cart.items.map(function(it){
      var img = it.image ? '<img src="'+it.image+'&width=144" alt="" loading="lazy">' : '';
      return '<div class="line"><span class="line__media">'+img+'</span>'+
        '<div class="line__body"><a class="line__title" href="'+it.url+'">'+escapeHtml(it.product_title)+'</a>'+
        '<div class="line__price">'+it.quantity+' \u00d7 '+formatMoney(it.final_price)+'</div>'+
        '<div class="qty" style="margin-top:.5em"><button type="button" data-qty="down" data-line="'+it.key+'" aria-label="Decrease quantity">\u2212</button>'+
        '<input type="text" value="'+it.quantity+'" readonly aria-label="Quantity"><button type="button" data-qty="up" data-line="'+it.key+'" aria-label="Increase quantity">+</button></div>'+
        '<button class="line__remove" type="button" data-cart-remove="'+it.key+'">Remove</button></div></div>';
    }).join('');
    if(sub) sub.querySelector('[data-subtotal]').textContent = formatMoney(cart.total_price);
    return cart;
  }

  /* ---------- product gallery ---------- */
  var stage = document.getElementById('pdp-stage-img');
  if(stage){
    document.querySelectorAll('.pdp__thumb').forEach(function(t){
      t.addEventListener('click', function(){
        var full = t.getAttribute('data-full');
        var alt = t.getAttribute('data-alt')||'';
        stage.src = full; stage.alt = alt;
        document.querySelectorAll('.pdp__thumb').forEach(function(x){ x.setAttribute('aria-current','false'); });
        t.setAttribute('aria-current','true');
      });
    });
  }

  /* ---------- scroll reveal ---------- */
  var reveals = document.querySelectorAll('.reveal');
  if(reveals.length){
    if('IntersectionObserver' in window && !reduce){
      var io = new IntersectionObserver(function(es){
        es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('is-in'); io.unobserve(e.target); } });
      }, {threshold:.1, rootMargin:'0px 0px -8% 0px'});
      reveals.forEach(function(el){ io.observe(el); });
      requestAnimationFrame(function(){
        var vh = innerHeight;
        reveals.forEach(function(el){ var r=el.getBoundingClientRect(); if(r.top<vh && r.bottom>0) el.classList.add('is-in'); });
      });
    } else {
      reveals.forEach(function(el){ el.classList.add('is-in'); });
    }
  }

  /* ---------- helpers ---------- */
  function escapeHtml(s){ return String(s).replace(/[&<>"']/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; }); }
  function formatMoney(cents){
    var v = (cents/100);
    return '\u20b9' + v.toLocaleString('en-IN', {minimumFractionDigits: v%1?2:0, maximumFractionDigits:2});
  }

  /* ---------- restrained hero parallax (scroll + pointer) ---------- */
  if(!reduce){
    var obj = document.querySelector('.hero__object');
    var niche = document.querySelector('.hero__niche');
    if(obj && niche){
      var sy = 0, px = 0, py = 0, raf = 0;
      var apply = function(){
        raf = 0;
        // scroll + pointer parallax written once per change — no perpetual loop
        obj.style.translate = px.toFixed(2) + 'px ' + (sy * -0.04 + py).toFixed(2) + 'px';
      };
      var schedule = function(){ if(!raf) raf = requestAnimationFrame(apply); };
      addEventListener('scroll', function(){
        var r = niche.getBoundingClientRect();
        if(r.bottom > 0 && r.top < innerHeight){ sy = (r.top + r.height/2) - innerHeight/2; schedule(); }
      }, {passive:true});
      // pointer parallax — very small, spring-free but eased via CSS transition
      niche.addEventListener('pointermove', function(e){
        var r = niche.getBoundingClientRect();
        px = ((e.clientX - r.left)/r.width - 0.5) * 10;
        py = ((e.clientY - r.top)/r.height - 0.5) * 10;
        schedule();
      });
      niche.addEventListener('pointerleave', function(){ px = 0; py = 0; schedule(); });
      // float animation (transform) and parallax (translate) compose independently
      obj.style.transition = 'translate .6s cubic-bezier(.23,1,.32,1)';
    }
  }

  /* ---------- stagger reveals within a group ---------- */
  document.querySelectorAll('.seven__list, .pgrid, .tgrid, .values').forEach(function(group){
    var kids = group.querySelectorAll('.reveal');
    kids.forEach(function(el, i){ el.style.transitionDelay = Math.min(i*50, 240) + 'ms'; });
  });

  /* ---------- appointment booking ---------- */
  var appt = document.querySelector('[data-appt]');
  if(appt){ initAppointment(appt); }

  function initAppointment(root){
    var grid = root.querySelector('[data-cal-grid]');
    var monthEl = root.querySelector('[data-cal-month]');
    var slotStep = root.querySelector('[data-slot-step]');
    var slotsEl = root.querySelector('[data-appt-slots]');
    var chosenDateEl = root.querySelector('[data-chosen-date]');
    var submitBtn = root.querySelector('[data-appt-submit]');
    var summaryEl = root.querySelector('[data-appt-summary]');
    var fDate = root.querySelector('[data-field-date]');
    var fTime = root.querySelector('[data-field-time]');
    var fIso  = root.querySelector('[data-field-iso]');
    var fBody = root.querySelector('[data-field-body]');
    var form = root.querySelector('form');
    if(!grid || !form){ return; }

    var daysAhead = parseInt(root.getAttribute('data-days-ahead'),10) || 21;
    var leadDays = parseInt(root.getAttribute('data-lead-days'),10) || 0;
    var closed = (root.getAttribute('data-closed-weekdays')||'').split(',').map(function(s){return parseInt(s.trim(),10);}).filter(function(n){return !isNaN(n);});
    var slots = (root.getAttribute('data-slots')||'').split(',').map(function(s){return s.trim();}).filter(Boolean);

    var MONTHS = ['January','February','March','April','May','June','July','August','September','October','November','December'];
    var today = new Date(); today.setHours(0,0,0,0);
    var minDate = new Date(today); minDate.setDate(minDate.getDate()+leadDays);
    var maxDate = new Date(today); maxDate.setDate(maxDate.getDate()+daysAhead);
    var view = new Date(minDate.getFullYear(), minDate.getMonth(), 1);
    var selected = null;

    function sameDay(a,b){ return a.getFullYear()===b.getFullYear() && a.getMonth()===b.getMonth() && a.getDate()===b.getDate(); }
    function bookable(d){
      if(d < minDate || d > maxDate) return false;
      if(closed.indexOf(d.getDay())>-1) return false;
      return true;
    }
    function fmtLong(d){ return d.toLocaleDateString('en-GB',{weekday:'long',day:'numeric',month:'long'}); }
    function to12h(t){
      var parts = t.split(':'); var h = parseInt(parts[0],10); var m = parts[1]||'00';
      var ap = h>=12?'PM':'AM'; var h12 = h%12; if(h12===0) h12=12;
      return h12+':'+m+' '+ap;
    }

    function renderMonth(){
      monthEl.textContent = MONTHS[view.getMonth()]+' '+view.getFullYear();
      grid.innerHTML='';
      var first = new Date(view.getFullYear(), view.getMonth(), 1);
      var startPad = (first.getDay()+6)%7; // Monday-first
      var dim = new Date(view.getFullYear(), view.getMonth()+1, 0).getDate();
      for(var i=0;i<startPad;i++){ var sp=document.createElement('span'); sp.className='appt-cal__pad'; grid.appendChild(sp); }
      for(var day=1; day<=dim; day++){
        var d = new Date(view.getFullYear(), view.getMonth(), day);
        var btn = document.createElement('button');
        btn.type='button'; btn.className='appt-cal__day'; btn.textContent=day;
        if(bookable(d)){
          btn.setAttribute('data-date', d.toISOString());
          if(selected && sameDay(d,selected)) btn.setAttribute('aria-pressed','true');
          btn.addEventListener('click', (function(dd){ return function(){ pickDate(dd); }; })(d));
        } else {
          btn.disabled = true; btn.classList.add('is-off');
        }
        grid.appendChild(btn);
      }
      // nav bounds
      var prev = root.querySelector('[data-cal-prev]'), next = root.querySelector('[data-cal-next]');
      prev.disabled = (view.getFullYear()===minDate.getFullYear() && view.getMonth()<=minDate.getMonth());
      next.disabled = (view.getFullYear()===maxDate.getFullYear() && view.getMonth()>=maxDate.getMonth());
    }

    function pickDate(d){
      selected = d;
      grid.querySelectorAll('.appt-cal__day').forEach(function(b){ b.setAttribute('aria-pressed','false'); });
      var active = grid.querySelector('[data-date="'+d.toISOString()+'"]');
      if(active) active.setAttribute('aria-pressed','true');
      chosenDateEl.textContent = '— '+fmtLong(d);
      slotStep.hidden = false;
      renderSlots();
      chosen.time = null; validate();
      slotStep.scrollIntoView({behavior: reduce?'auto':'smooth', block:'nearest'});
    }

    var chosen = { time:null };
    function renderSlots(){
      slotsEl.innerHTML='';
      slots.forEach(function(t){
        var b=document.createElement('button');
        b.type='button'; b.className='appt-slot'; b.setAttribute('role','radio'); b.setAttribute('aria-checked','false');
        b.textContent = to12h(t); b.setAttribute('data-time', t);
        b.addEventListener('click', function(){
          slotsEl.querySelectorAll('.appt-slot').forEach(function(x){ x.setAttribute('aria-checked','false'); });
          b.setAttribute('aria-checked','true'); chosen.time = t; validate();
        });
        slotsEl.appendChild(b);
      });
    }

    function validate(){
      var ok = selected && chosen.time;
      if(ok){
        var iso = new Date(selected); var hm = chosen.time.split(':');
        iso.setHours(parseInt(hm[0],10), parseInt(hm[1]||0,10),0,0);
        fDate.value = fmtLong(selected);
        fTime.value = to12h(chosen.time);
        fIso.value = iso.toISOString();
        summaryEl.hidden = false;
        summaryEl.textContent = 'Requested: '+fmtLong(selected)+' at '+to12h(chosen.time);
      } else {
        summaryEl.hidden = true;
      }
      submitBtn.disabled = !ok;
    }

    form.addEventListener('submit', function(e){
      if(!(selected && chosen.time)){ e.preventDefault(); return; }
      var purpose = (root.querySelector('#appt-purpose')||{}).value || '';
      var notes = (root.querySelector('#appt-notes')||{}).value || '';
      fBody.value =
        'Appointment request\n' +
        'Date: '+fDate.value+'\n' +
        'Time: '+fTime.value+'\n' +
        'Purpose: '+purpose+'\n' +
        (notes ? 'Notes: '+notes+'\n' : '') +
        'Scheduled (ISO): '+fIso.value;
    });

    root.querySelector('[data-cal-prev]').addEventListener('click', function(){ view.setMonth(view.getMonth()-1); renderMonth(); });
    root.querySelector('[data-cal-next]').addEventListener('click', function(){ view.setMonth(view.getMonth()+1); renderMonth(); });
    renderMonth();
  }

  /* ---------- product card 3D tilt ----------
     A quiet depth cue on hover: the card tilts toward the cursor within a
     few degrees, then eases back to flat. Fine-pointer devices only —
     touch screens get the plain lift/shadow already defined in CSS. */
  if(!reduce && matchMedia('(hover:hover) and (pointer:fine)').matches){
    var TILT_MAX = 6; // degrees — restrained, not a gimmick
    document.querySelectorAll('.card').forEach(function(card){
      var raf = 0;
      card.addEventListener('pointermove', function(e){
        if(raf) return;
        raf = requestAnimationFrame(function(){
          raf = 0;
          var r = card.getBoundingClientRect();
          var px = (e.clientX - r.left) / r.width;
          var py = (e.clientY - r.top) / r.height;
          var ry = (px - 0.5) * TILT_MAX * 2;
          var rx = (0.5 - py) * TILT_MAX * 2;
          card.style.transition = 'transform .1s linear';
          card.style.transform = 'perspective(900px) rotateX('+rx.toFixed(2)+'deg) rotateY('+ry.toFixed(2)+'deg) translateY(-4px)';
        });
      });
      card.addEventListener('pointerleave', function(){
        if(raf){ cancelAnimationFrame(raf); raf=0; }
        card.style.transition = 'transform .6s var(--ease)';
        card.style.transform = 'perspective(900px)';
      });
    });
  }

  /* init cart count on load */
  if(document.querySelector('[data-cart-count]')) refreshCart();
})();
